/** Button样式类型 */
export enum DetailButtonType {
  /** 绿底白字 */
  primary = 'primary',
  /** 灰底绿字 */
  ghost = 'ghost',
  /** 灰底深灰色字 */
  outofperiod = 'outofperiod',
}

/** Button尺寸 */
export enum DetailButtonSize {
  /** 116*56px */
  small = 'small',
  /** 368 * 80px */
  normal = 'normal',
}

/** Button 的props属性 */
export type DetailBtnConfig = {
  /** 是否disabled */
  isDisabled?: boolean;
  /** 是否展示按钮 */
  isShowBtn?: boolean;
  /** 按钮文案 */
  btnText?: string;
  /** 尺寸，有normal(368*80px)、small(116*56px)两种 */
  size?: DetailButtonSize;
  /** 样式类型，有primary(绿底白字)、ghost(灰底绿字)、outofperiod(灰底深灰色字)三种 */
  type?: DetailButtonType;
};
